import React, { useEffect, useRef, useState } from 'react';
import { useField } from '@unform/core';
import { FormHelperText, InputLabel } from '@material-ui/core';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { optionStyles } from './styles';

interface Props {
  name?: string;
  defaultValue?: string;
  label?: string;
  required?: boolean;
  type: string;
  placeholder: string;
  readonly?: boolean;
  onTextChange?: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
}
type InputProps = JSX.IntrinsicElements['input'] & Props;

const Input: React.FC<InputProps> = ({
  name = '',
  label,
  type,
  placeholder,
  required,
  onTextChange,
  readOnly,
  ...rest
}) => {
  const classes = optionStyles();

  const inputRef = useRef<HTMLInputElement>(null);
  const { fieldName, registerField, error, defaultValue } = useField(name);
  const [value, setValue] = useState<string>('');
  const [show, SetShow] = useState(false);
  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField, value, defaultValue]);

  function handleShow() {
    if (inputRef.current?.type === 'password' && inputRef.current?.name === 'password') {
      SetShow(true);
      inputRef.current.type = 'text';
    }
    if (
      inputRef.current?.type === 'password' &&
      inputRef.current?.name === 'newPassword'
    ) {
      SetShow(true);
      inputRef.current.type = 'text';
    }
  }
  function handleHide() {
    if (inputRef.current?.type === 'text' && inputRef.current?.name === 'password') {
      SetShow(false);
      inputRef.current.type = 'password';
    }
    if (inputRef.current?.type === 'text' && inputRef.current?.name === 'newPassword') {
      SetShow(false);
      inputRef.current.type = 'password';
    }
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
    if (onTextChange) onTextChange(event);
  };

  return (
    <div className={classes.inputContainer}>
      {label && (
        <InputLabel
          error={!!error && !value}
          htmlFor={fieldName}
          className={classes.label}
        >
          {label}
        </InputLabel>
      )}
      <div className={`${classes.inputContent}  ${readOnly ? classes.readOnly : ''}`}>
        <input
          id={fieldName}
          ref={inputRef}
          name={name}
          type={type}
          placeholder={placeholder}
          className={classes.input}
          defaultValue={defaultValue}
          onChange={handleChange}
          required={!!required}
          readOnly={!!readOnly}
          {...rest}
        />
        {type === 'password' ? (
          show ? (
            <button
              type="button"
              onClick={() => handleHide()}
              className={classes.buttonEye}
            >
              <FaEyeSlash />
            </button>
          ) : (
            <button
              type="button"
              onClick={() => handleShow()}
              className={classes.buttonEye}
            >
              <FaEye />
            </button>
          )
        ) : (
          <></>
        )}
      </div>
      {error && !value && (
        <FormHelperText style={{ color: '#f44336' }}>{error}</FormHelperText>
      )}
    </div>
  );
};

export default Input;
